<template lang="pug">
md-table-card.card
  md-layout(md-column='', md-align='start')
  form(novalidate='', @submit.stop.prevent='search')
    md-layout.search(md-align='end')
      md-layout.searchContainer(md-flex='33', md-align='end')
        md-layout
          md-input-container
            label Search
            md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
        md-layout(md-flex='15', v-if='searchText != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
        md-layout(md-flex='10')
          md-button.search-btn.md-icon-button.btn(type='submit', :disabled='loading')
            md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(:loading='loading', :size='45')
    .domains(v-if='domains.length > 0')
      div.titleLine.styleRow
          p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
          p.rowElements Status
          p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
          p.rowElements
      div.styleRow.colorHover(v-for='domain in domains', :key='domain._id')
        div.rowElements {{domain.name}}
        div.rowElements(v-if="domain.status === 'public'") live
        div.rowElements(v-else) {{ domain.status }}
        div.rowElements {{ domain.lastUpdated | moment('from') }}
        div.rowElements
          md-button.md-icon-button.md-raised.btn(@click='editDomain(domain._id)')
            md-icon.icon(md-iconset="fa fa-pencil-alt")
      md-table-pagination(
        :md-size='currentPagination.size',
        :md-total='totalDomains',
        :md-page='currentPagination.page',
        md-label='Domains',
        md-separator='of',
        :md-page-options='[10, 25, 50, 100]',
        @pagination='onPageChanged'
      )
    div#no-results(v-else)
      div.message
        md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
        | No items to show

    md-layout(md-align='center')
      md-button#submit-btn.md-raised.md-primary.handPointer(@click='downloadDomainBlackList()', :disabled='loading' ) {{ downloadBlackListStatus }}

    form(novalidate='', @submit.stop.prevent='updateDomainsBlackList', v-if='isAdmin() || isAccountAdmin()')
      md-layout(md-align='center', v-show='!loading')
        md-layout(md-flex='40')
          md-input-container
            label File to update
            md-file.search-btn(v-model='blackListFileName', accept='.csv', @selected='onBlackListFileSelected')
            md-button#submit-btn.md-raised.md-primary(type='submit', :disabled='loading || this.blackListFile === null' )
              | {{ updateBLstatus }}
</template>

<script>
import csvToArray from "../../common/utils/csvToArray";
import domainService from "../../services/domainService";
import stitchLoader from "../../shared-components/Loader";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    stitchLoader,
  },
  data() {
    return {
      bulkStatus: "Bulk Upload",
      domains: [],
      totalDomains: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10,
      },
      sort: {
        name: "lastUpdated",
        type: "desc",
      },
      searchText: "",
      fileName: "",
      file: null,
      blackListFileName: "",
      blackListFile: null,
      updateBLstatus: "Update blocklist",
      downloadBlackListStatus: "Click here to consult blocked domains",
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset:
          this.searchText || this.currentPagination.page == 1
            ? 0
            : this.currentPagination.size * (this.currentPagination.page - 1),
        limit:
          this.$session.get("limitPaginationDomains") ||
          this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type,
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalDomains != null && params.offset >= this.totalDomains) {
        params.offset = 0;
      }

      return params;
    },
    ...mapGetters("user", ["getFeatureValue"]),
    ...mapState({
      siteuser: (state) => state.user.siteuser,
    }),
  },
  methods: {
    showAlertToast(text, icon){
        this.$swal({
              text: text,
              position: 'bottom-left',
              icon: icon,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
              }
            )
      },

    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageDomains", paginationParams.page);
      this.$session.set("limitPaginationDomains", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },
    search() {
      this.loading = true;
      domainService
        .getList(this.searchParams)
        .then((response) => {
          this.domains = response.data.domainLists;
          this.totalDomains = response.data.total;
        })
        .catch((error) => {
          console.error("Error while retrieving the list of domains", error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    editDomain(domainId) {
      this.$router.push({
        name: "EditDomainList",
        params: {
          id: domainId,
        },
      });
    },
    onFileSelected(files) {
      this.bulkStatus = "Bulk Upload";
      this.file = files[0];
    },
    onBlackListFileSelected(files) {
      this.updateBLstatus = "Update blocklist";
      this.blackListFile = files[0];
    },
    bulkUpload() {
      const reader = new FileReader();
      reader.readAsText(this.file);
      reader.onload = (event) => {
        this.bulkStatus = "Uploading domains by CSV file, please wait...";
        let blackListDomain = false;
        let repeatedDomain = false;
        let repeatedDomainInCSV = false;
        let repeatedDomainNames = [];
        let blackListDomainNames = [];
        const csvParsedData = csvToArray(event.target.result);
        if (!csvParsedData) {
          this.bulkStatus = "Error uploading";
          this.showAlertToast('Domain list could not be created. Malformed CSV', 'error');
          return;
        }
        domainService
          .getAll()
          .then((response) => {
            const domainArray = response.data.domainList;
            const domainsInDB = domainArray.map((domain) => {
              return domain.domains;
            });
            domainService.getBlackList().then((blackListedDomains) => {
              const domainsInBlackList = blackListedDomains.data;

              const newDomainNamesInCSV = csvParsedData.map((newDomain) => {
                return newDomain.domains;
              });
              function checkIfArrayIsUnique(myArray) {
                return myArray.some((val, i) => myArray.indexOf(val) !== i);
              }
              repeatedDomainInCSV = checkIfArrayIsUnique(
                newDomainNamesInCSV.flat()
              );

              if (repeatedDomainInCSV) {
                this.bulkStatus = "Error uploading";
                this.showAlertToast('There are repeated domains in the CSV file', 'error');
                return;
              }

              csvParsedData.map((newDomain) => {
                newDomain.domains.some((element) => {
                  if (domainsInDB.flat().includes(element)) {
                    repeatedDomain = true;
                    if (!repeatedDomainNames.includes(element)) {
                      repeatedDomainNames.push(element);
                    }
                  }
                  if (domainsInBlackList.includes(element)) {
                    blackListDomain = true;
                    if (!blackListDomainNames.includes(element)) {
                      blackListDomainNames.push(element);
                    }
                  }
                });
              });

              if (repeatedDomain) {
                this.bulkStatus = "Error uploading";
                this.showAlertToast(`Domain name already exists: ${repeatedDomainNames.toString()}`, 'error');
                return;
              } else if (blackListDomain) {
                this.bulkStatus = "Error uploading";
                this.showAlertToast(`You have blocked domain(s): ${blackListDomainNames.toString()}`, 'error');
                return;
              } else {
                domainService
                  .bulkUpload(csvParsedData)
                  .then(() => {
                    this.bulkStatus = "OK!";
                    this.showAlertToast('Domain list created successfully', 'success');
                    setTimeout(() => {
                      this.search();
                    }, 2000);
                  })
                  .catch(() => {
                    this.bulkStatus = "Error uploading";
                    this.showAlertToast('Domain list could not be created. Please, try again later', 'error');
                  });
              }
            });
          })
          .catch((error) => {
            console.error(
              "Domain list could not be created. Please, try again later.",
              error
            );
          });
      };
    },
    isAdmin() {
      // Check user has 'authorization' and Check user has 'roles'
      if (this.siteuser.authorization && this.siteuser.authorization.roles) {
        return this.siteuser.authorization.roles.includes("Admin");
      }
      return false;
    },
    isAccountAdmin() {
      // Check user has 'authorization' and Check user has 'roles'
      if (this.siteuser.authorization && this.siteuser.authorization.roles) {
        return this.siteuser.authorization.roles.includes("AccountAdmin");
      }
      return false;
    },
    updateDomainsBlackList() {
      this.updateBLstatus = "Uploading ...";
      const reader = new FileReader();
      reader.readAsText(this.blackListFile);
      reader.onload = (event) => {
        const csv = event.target.result;
        const arrayDomains = csv.split(/\r?\n/);

        domainService
          .updateBlackList(arrayDomains)
          .then(() => {
            this.updateBLstatus = "Success!";
            this.blackListFileName = "",
            this.blackListFile = null,
            this.showAlertToast('Domain blocked list updated successfully', 'success');
            setTimeout(() => {
              this.updateBLstatus = "Update blocklist";
              this.search();
            }, 2000);
          })
          .catch((error) => {
            this.updateBLstatus = "Error";
            console.log(
              "🚀 ~ file: DomainTable.vue ~ line 312 ~ updateDomainsBlackList ~ error",
              error
            );
            this.bulkStatus = "Error updating blocklist";
            this.showAlertToast('Domain blocked list could not be updated. Please, try again later', 'error');
          });
      };
    },
    downloadSampleFile() {
      window.location.href = "/static/sample_bulk_upload_domain.csv";
    },
    downloadDomainBlackList() {
      this.downloadBlackListStatus = "Downloading... ";
      domainService
        .getBlackList()
        .then((blackListedDomains) => {
          const rows = [blackListedDomains.data];

          let csvContent =
            "data:text/csv;charset=utf-8," + rows.map((e) => e.join("\n"));
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "Rhebus blocked domains.csv");
          document.body.appendChild(link); // Required for FF

          link.click();
          this.downloadBlackListStatus = "Success!";
          setTimeout(() => {
            this.downloadBlackListStatus = "Click here to consult blocked domains";
          }, 2000);
        })
        .catch((error) => {
          this.updateBLstatus = "Error";
          console.log(
            "🚀 ~ file: DomainTable.vue ~ line 312 ~ updateDomainsBlackList ~ error",
            error
          );
          this.bulkStatus = "Error updating blocklist";
          this.showAlertToast('Domain blocked list could not be updated. Please, try again later', 'error');
        });
    },
    cleanSearchText() {
      this.searchText = "";
      this.search();
    },
  },
  mounted() {
    this.$session.set("limitPagination", this.currentPagination.size);

    if (this.$session.get("iWasInPageDomains") === undefined) {
      this.$session.set("iWasInPageDomains", 1);
    }
    this.currentPagination.page = this.$session.get("iWasInPageDomains");
    if(this.$session.get("limitPaginationDomains") !== undefined){
      this.currentPagination.size = this.$session.get("limitPaginationDomains");
    }
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageChannel", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch:{
  currentPagination(newValue, oldValue) {
      if(newValue.size !== oldValue.size){
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card{
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}
.search{
  margin-right: 10px;
  @media (max-width: 1200px) {
      margin-right: 20px;
  }
}
.searchContainer{
  flex: none;
}
.search-btn {
  padding-left: 15px;
}

.bulk-upload-btn {
  margin: 16px 10px 0px 0px;
}

.bulk-upload-ico {
  color: #fff;
}

.bulk-upload {
  height: 200px;
  width: 50%;
}

.md-table {
  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

.handPointer {
  cursor: pointer;
  color: #4ea9dd;
}

#no-results {
  display: flex;
  padding: 20px;
  .message{
    margin: auto;
  }
  .md-icon {
    margin-right: 5px;
  }
}

.styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}
.colorHover:hover{
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover{
  cursor: pointer;
  color: #4ea9dd;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/domain/DomainTable.vue